"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const xstate_1 = require("xstate");
const prop_types_1 = require("prop-types");
const DesktopHeader_1 = __importDefault(require("./DesktopHeader"));
const MobileHeader_1 = __importDefault(require("./MobileHeader"));
const configUtils_1 = require("../../lib/configUtils");
const States_1 = require("./../../lib/constants/States");
const stepPropsFromState = (currentState, stepsConfiguration) => {
    const currentStateKey = typeof currentState.value === 'string'
        ? currentState.value
        : Object.keys(currentState.value)[0];
    const activeStep = stepsConfiguration
        ? stepsConfiguration.findIndex(({ stateKey, stepperLabelId }) => stepperLabelId !== null && stateKey === currentStateKey)
        : -1;
    return {
        activeStepIndex: activeStep !== -1 ? activeStep : 0
    };
};
const propTypes = {
    onGoBack: prop_types_1.func.isRequired,
    currentState: (0, prop_types_1.instanceOf)(xstate_1.State).isRequired,
    aboveMd: prop_types_1.bool.isRequired,
    config: prop_types_1.object.isRequired,
    /** header will not render without this configuration object. See lib/constants/steps */
    stepsConfiguration: (0, prop_types_1.arrayOf)(prop_types_1.object),
    backToSearchPageURL: prop_types_1.string,
    searchMatchEnabled: prop_types_1.bool.isRequired,
    track: prop_types_1.func.isRequired,
    featureFlags: (0, prop_types_1.shape)({
        dbw_suggest_alt_providers_for_step_1: prop_types_1.bool,
        dbw_suggest_alt_providers_for_step_2: prop_types_1.bool,
        dbw_render_in_drawer: prop_types_1.bool
    }),
    isOrderBasedSchedulingFlow: prop_types_1.bool
};
const Header = (0, react_1.forwardRef)(({ onGoBack, currentState, aboveMd, config, featureFlags, stepsConfiguration, searchMatchEnabled, backToSearchPageURL, isOrderBasedSchedulingFlow, track }, ref) => {
    const isApptSummary = currentState.matches(States_1.apptSummary);
    const { activeStepIndex } = stepPropsFromState(currentState, stepsConfiguration);
    const { hideHeader } = currentState.context;
    if (hideHeader) {
        return null;
    }
    if (!aboveMd || (0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags)) {
        return (react_1.default.createElement(MobileHeader_1.default, { ref: ref, activeStep: activeStepIndex, searchMatchEnabled: searchMatchEnabled, backToSearchPageURL: backToSearchPageURL, onGoBack: onGoBack, config: config, featureFlags: featureFlags, stepsConfiguration: stepsConfiguration, track: track, isApptSummary: isApptSummary }));
    }
    if (aboveMd && !isApptSummary) {
        return (react_1.default.createElement(DesktopHeader_1.default, { ref: ref, activeStep: activeStepIndex, searchMatchEnabled: searchMatchEnabled, backToSearchPageURL: backToSearchPageURL, onGoBack: onGoBack, stepsConfiguration: stepsConfiguration, isOrderBasedSchedulingFlow: isOrderBasedSchedulingFlow, track: track }));
    }
    return null;
});
Header.displayName = 'Header';
Header.propTypes = propTypes;
exports.default = Header;
//# sourceMappingURL=Header.js.map